import { render } from "./IconTurnRight.vue?vue&type=template&id=3a519e54"
import script from "./IconTurnRight.vue?vue&type=script&lang=js"
export * from "./IconTurnRight.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__